// src/pages/ContactPage.js
import '../utils/axiosConfig'; // runs the 401/403 logout logic globally
import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import '../Style/ContactPage.css';
import { FaEnvelope, FaLinkedin } from 'react-icons/fa';

// image imports
import solomon from '../Images/Solomon.jpg';
import zippie from '../Images/Zippie.png';
import sandeep from '../Images/Sandeep.png';
import coleman from '../Images/Coleman.jpg';
import amartey from '../Images/Amartey.jpg';
import barr from '../Images/Barr.jpg';
import ravat from '../Images/Ravat.jpg';
import melissa from '../Images/melissa.jpg';

export default function ContactPage() {
  const { t } = useLanguage();
  const ccList = 'go-fmafricaprivateen@kpmg.com';

  const makeLinks = (email) => {
    const to = encodeURIComponent(email);
    const cc = encodeURIComponent(ccList);
    return {
      default: `mailto:${to}?cc=${cc}`,
      gmail: `https://mail.google.com/mail/?view=cm&fs=1&to=${to}&cc=${cc}`,
      outlook: `https://outlook.office.com/mail/deeplink/compose?to=${to}&cc=${cc}`
    };
  };

  const mainContact = {
    name: 'Sandeep Main',
    title: 'Lead Partner - KPMG Africa Private Enterprise',
    email: 'sandeepmain@kpmg.co.ke',
    linkedin: 'https://www.linkedin.com/in/sandeep-main/',
    img: sandeep
  };

  const regions = [
    {
      name: 'West Africa',
      contacts: [
        {
          name: 'Coleman, Joyceline',
          title: 'Partner',
          email: 'joycelinecoleman@kpmg.com',
          linkedin: 'https://www.linkedin.com/in/joyceline-nhyira-coleman-517b2a29/',
          img: coleman
        },
        {
          name: 'Amartey-Kwei, Justina',
          title: 'Partner',
          email: 'jamartey-kwei@kpmg.com',
          linkedin: 'https://www.linkedin.com/in/justina-amartey-kwei-75277128/',
          img: amartey
        },
        {
          name: 'Melissa, Akita',
          title: 'Manager',
          email: 'mlakita@kpmg.com',
          linkedin: 'https://www.linkedin.com/in/melissa-allotey/',
          img: melissa
        },
      ]
    },
    {
      name: 'East Africa',
      contacts: [
        {
          name: 'Solomon, Kihanga',
          title: 'Senior Manager',
          email: 'skihanga@kpmg.co.ke',
          linkedin: 'https://www.linkedin.com/in/solomon-kihanga/',
          img: solomon
        },
        {
          name: 'Zipporah, Mucheke',
          title: 'Senior',
          email: 'zmucheke@kpmg.co.ke',
          linkedin: 'https://www.linkedin.com/in/zipporah-m-020474117/',
          img: zippie
        },
      ]
    },
    {
      name: 'Southern Africa',
      contacts: [
        {
          name: 'Barr, Alan',
          title: 'Partner',
          email: 'alan.barr@kpmg.co.za',
          linkedin: 'https://www.linkedin.com/in/alan-barr-ca-sa-3a07321/',
          img: barr
        },
        {
          name: 'Ravat, Ziyaad',
          title: 'Partner',
          email: 'ziyaad.ravat@kpmg.co.za',
          linkedin: 'https://www.linkedin.com/in/ziyaadravat/',
          img: ravat
        },
      ]
    }
  ];

  const renderContact = contact => {
    const links = makeLinks(contact.email);
    return (
      <div key={contact.email} className="contact-card">
        <img src={contact.img} alt={contact.name} className="profile-pic" />
        <div className="contact-info">
          <p className="contact-name">{contact.name}</p>
          <p className="contact-title">{contact.title}</p>
          <p className="contact-email">
            <a href={links.default} className="email-icon">
              <FaEnvelope />
            </a>
            <a href={links.gmail} target="_blank" rel="noopener noreferrer" className="email-text">
              Gmail
            </a>
            <a href={links.outlook} target="_blank" rel="noopener noreferrer" className="email-text">
              Outlook
            </a>
            {contact.linkedin && (
              <a
                href={contact.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="linkedin-icon"
                title={`Connect with ${contact.name} on LinkedIn`}
              >
                <FaLinkedin />
              </a>
            )}
          </p>
        </div>
      </div>
    );
  };

  return (
    <div className="contact-container">
      <h2>{t('contact_title')}</h2>

      {/* Main Key Contact */}
      <div className="contact-card main-contact-card">
        <img src={mainContact.img} alt={mainContact.name} className="profile-pic" />
        <div className="contact-info">
          <p className="contact-name">{mainContact.name}</p>
          <p className="contact-title">{mainContact.title}</p>
          <p className="contact-email">
            <a href={makeLinks(mainContact.email).default} className="email-icon">
              <FaEnvelope />
            </a>
            <a
              href={makeLinks(mainContact.email).gmail}
              target="_blank"
              rel="noopener noreferrer"
              className="email-text"
            >
              Gmail
            </a>
            <a
              href={makeLinks(mainContact.email).outlook}
              target="_blank"
              rel="noopener noreferrer"
              className="email-text"
            >
              Outlook
            </a>
            {mainContact.linkedin && (
              <a
                href={mainContact.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="linkedin-icon"
                title={`Connect with ${mainContact.name} on LinkedIn`}
              >
                <FaLinkedin /> 
              </a>
            )}
          </p>
        </div>
      </div>

      {/* Regional Contacts */}
      <div className="regions-grid">
        {regions.map(region => (
          <div key={region.name} className="region-group">
            <h3 className="region-name">{region.name}</h3>
            {region.contacts.map(renderContact)}
          </div>
        ))}
      </div>
    </div>
  );
}
